
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  '3-blocks': {
    width: 21.5,
    height: 21.5,
    viewBox: '0 0 21.5 21.5',
    data: '<path pid="0" class="st0" d="M7.35 21.45h-5c-1.3 0-2.3-1.1-2.4-2.3v-4.9c0-1.3 1.1-2.3 2.3-2.4h4.9c1.3 0 2.3 1 2.4 2.3v4.9c.1 1.2-.9 2.3-2.2 2.4zm0-1.5c.3 0 .5-.1.6-.3.1-.2.2-.4.2-.6v-4.9c0-.5-.4-.9-.9-.9h-4.9c-.5 0-.9.4-.9.9v4.9c0 .5.4.9.9.9h5zm11.8 1.5h-5c-1.3 0-2.3-1.1-2.4-2.3v-4.9c0-1.3 1-2.3 2.3-2.4h4.9c1.3 0 2.3 1 2.4 2.3v4.9c0 .6-.2 1.2-.7 1.6-.3.5-.9.8-1.5.8zm-.1-8.1h-4.9c-.5 0-.9.4-.9.9v4.9c0 .5.4.9.9.9h5c.2 0 .4-.1.6-.3.2-.2.2-.4.2-.6v-4.9c0-.5-.4-.9-.9-.9zm-6.1-3.7h-5c-1.3 0-2.3-1-2.4-2.3v-5c0-1.3 1.1-2.3 2.3-2.4h4.9c1.3 0 2.3 1.1 2.4 2.3v4.9c.2 1.4-.8 2.5-2.2 2.5zm0-1.5c.5 0 .8-.4.8-.9v-4.9c0-.5-.4-.9-.9-.9h-4.8c-.5 0-.9.4-.9.9v4.9c0 .5.4.9.9.9h4.9z"/>'
  }
})
